import { useCallback, useEffect, useState } from "react";
import { TicketService } from "../services/TicketService";
import { DashboardService } from "../services/DashboardService";

export const useHookDashboardSummery = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const [params, setParams] = useState({});

    const getData = useCallback(async () => {
        setLoading(true);
        setError(null);

        try {
            const res = await DashboardService.get({ params });

            setData(res?.data?.data);
        } catch (err) {
            console.error(err);
            setError(err?.response?.data || err);
        } finally {
            setLoading(false);
        }
    }, [params]);

    useEffect(() => {
        getData();
    }, [getData]);

    return {
        data,
        loading,
        error,

        params,
        setParams,

        refreshData: getData,
    };
};